import { Image } from "@chakra-ui/react";
import { useState } from "react";

import { Container, ContentData, ContentImage, TextName, TextDescription, TextValueCod } from "./styles";

type ProdutoData = {
	id: string;
	categoria: string;
	cod_barras: string;
	cod_pro: string;
	comiss_ind: number;
	comiss_ven: number;
	complementos: ComplementoData[];
	descricao: string;
	nome: string;
	obs: string;
	promocao: string;
	qtd: number;
	url_imagem: string;
	valor: number;
	valorFormatted: string;
	total: number;
	totalFormatted: string;
}
type ComplementoData = {
	codigo: number;
	grupo: number;
	nome: string;
	descricao: string;
	custo: number;
	valor: number;
	priceFormatted: string;
	qtd_maxima: number;
	qtd_gratis: number;
	qtd: number;
}
interface ProdutoItemParams {
	produto: ProdutoData;
	setProdutoItemModal: (produto: ProdutoData) => void;
	setIsNewItemModal: (open: boolean) => void;
	setIsAddNewItem: (add: boolean) => void;
}

const ProdutoItem: React.FC<ProdutoItemParams> = ({
	produto,
	setProdutoItemModal,
	setIsNewItemModal,
	setIsAddNewItem,
}) => {
	const [image, setImage] = useState(produto.url_imagem
		? produto.url_imagem
		: "https://safetycloud.blob.core.windows.net/cashback-promocoes/placeholder-image.png"
	);
	const [imageWH, setImageWH] = useState('9.6875rem'); // 9.6875rem = 155px

	return (
		<Container
			onClick={() => {
				setProdutoItemModal(produto);
				setIsNewItemModal(true);
				setIsAddNewItem(true);
			}}
		>
			<ContentData>
				<TextName>{produto.nome}</TextName>

				<TextDescription>{produto.descricao}</TextDescription>

				<TextValueCod>{produto.valorFormatted} - Cod {produto.cod_barras}</TextValueCod>
			</ContentData>

			<ContentImage imageWH={imageWH}>
				<Image
					height="auto"
					width="auto"
					ml="2"
					maxW={imageWH} // {produto.url_imagem ? "150px" : "100px"}
					maxH={imageWH} // {produto.url_imagem ? "150px" : "100px"}
					borderRadius="10"
					loading="lazy" // "eager"
					objectFit="cover"
					src={image}
					alt={produto.nome}
					onError={() => {
						setImageWH('6.25rem'); // 6.25rem = 100px
						setImage("https://safetycloud.blob.core.windows.net/cashback-promocoes/image404.png");
					}}
					fallbackStrategy="beforeLoadOrError"
				/>
			</ContentImage>
		</Container>
	)
}

export default ProdutoItem;